const styles = (theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  image: {
    marginTop: 150,
    display: 'inline-block',
    maxWidth: '100%',
    width: 400,
  },
  subtitle: {
    maxWidth: 800,
  },
})

export default styles
